<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getStateName } from '@/libs/utils/workflows.js'
import { getWorkflow } from '@/services/workflowService.js'
import { getCampaign } from '@/services/campaignService.js'

import Loading from '@/components/Generics/Loadings/Loading.vue'
import ButtonTornaAllaLista from '@/components/Generics/Buttons/ButtonTornaAllaLista.vue'
import QuestionGroupStatistics from '@/components/PollTemplate/Components/QuestionGroupStatistics.vue'

const props = defineProps(['updatePageTitle'])
const route = useRoute()
const router = useRouter()

const canView = ref(false)
const loading = ref(true)
const pollTemplate = ref(null)
const campaign = ref(null)
const statistics = ref(null)
const workflow = ref(null)

onMounted(async () => {
  canView.value = route.meta.permissions.canView ?? false

  if (!canView.value) {
    return
  }

  loading.value = true
  campaign.value = await getCampaign(route.query.idCampaign, {poll: 1})
  pollTemplate.value = campaign.value['poll']
  statistics.value = await getCampaign(campaign.value.id, {stats: 1, revisionNumber: campaign.value.pollTemplateRevisionNumber})

  const wf = await getWorkflow(statistics.value.workflow)
  workflow.value = wf.data

  loading.value = false
  props.updatePageTitle('Statistiche risposte per: ' + statistics.value?.poll?.title)
})

</script>

<template>

  <div class="container-fluid px-0">
    <div class="col-12">
      <div class="card">

        <loading v-if="loading"></loading>

        <div class="card-body" v-else-if="!loading">
          <h5>Compilazioni:</h5>
          <ul v-if="statistics">
            <li v-for="(num, state) in statistics.stats" :key="state">
              {{ getStateName(state, [workflow]) }}: {{ num }}
            </li>
          </ul>
          <h6>Domande</h6>
          <question-group-statistics
            v-if="statistics"
            v-for="(questionGroup) in statistics['poll']['questionGroups']"
            :key="questionGroup.id"
            :statistics="statistics"
            :workflow="workflow"
            :workflows="[workflow]"
            :question-group="questionGroup">
          </question-group-statistics>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <button-torna-alla-lista class="me-auto" @click="router.back()"></button-torna-alla-lista>
    </div>

  </div>
</template>
